export enum CustomerActionType {
	UPLOAD_FLOOR_PLAN = 'UPLOAD_FLOOR_PLAN',

	VERIFY_CUSTOMER_OTP = 'VERIFY_CUSTOMER_OTP',
	VERIFY_CUSTOMER_OTP_FAILED = 'VERIFY_CUSTOMER_OTP_FAILED',

	SEND_CUSTOMER_OTP = 'SEND_CUSTOMER_OTP',
	SEND_CUSTOMER_OTP_FAILED = 'SEND_CUSTOMER_OTP_FAILED',
	SEND_CUSTOMER_OTP_SUCCESS = 'SEND_CUSTOMER_OTP_SUCCESS',

	RESEND_CUSTOMER_OTP = 'RESEND_CUSTOMER_OTP',

	// SET_QUOTATION_ID = 'SET_QUOTATION_ID',
	SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS',

	SET_LEAD_NAME = 'SET_LEAD_NAME',

	RESET_QUOTATIONS = 'RESET_QUOTATIONS',

	FETCH_QUOTATIONS = 'FETCH_QUOTATIONS',
	STORE_QUOTATIONS = 'STORE_QUOTATIONS',
	ERROR_FETCH_QUOTATIONS = 'ERROR_FETCH_QUOTATIONS',

	ADD_QUOTATION = 'ADD_QUOTATION',

	FETCH_CUSTOMER_DETAILS = 'FETCH_CUSTOMER_DETAILS',
	STORE_CUSTOMER_DETAILS = 'STORE_CUSTOMER_DETAILS',
	ERROR_CUSTOMER_DETAILS = 'ERROR_CUSTOMER_DETAILS',

	STORE_FLOOR_PLAN_DOC_ID = 'STORE_FLOOR_PLAN_DOC_ID',

	UPDATE_QUOTATION = 'UPDATE_QUOTATION',
	STORE_PREDICTION_ID = 'STORE_PREDICTION_ID',

	GET_PREDICTION_ID = 'GET_PREDICTION_ID',
	GET_PREDICTION = 'GET_PREDICTION',
	STORE_AREAS = 'STORE_AREAS',
	PREDICTION_FAILED = 'PREDICTION_FAILED',

	GET_PRE_DESIGN_QUOTATION = 'GET_PRE_DESIGN_QUOTATION',
	STORE_PRE_DESIGN_QUOTATION = 'STORE_PRE_DESIGN_QUOTATION',
	ERROR_PRE_DESIGN_QUOTATION = 'ERROR_PRE_DESIGN_QUOTATION',

	GET_DEFAULT_QUOTATION = 'GET_DEFAULT_QUOTATION',
	STORE_DEFAULT_QUOTATION = 'STORE_DEFAULT_QUOTATION',
	ERROR_DEFAULT_QUOTATION = 'ERROR_DEFAULT_QUOTATION',

	SET_LEAD_AND_PROJECT_ID = 'SET_LEAD_AND_PROJECT_ID',

	FETCH_FLOOR_PLAN_IMAGES = 'FETCH_FLOOR_PLAN_IMAGES',
	STORE_FLOOR_PLAN_IMAGES = 'STORE_FLOOR_PLAN_IMAGES',
	ERROR_FLOOR_PLAN_IMAGES = 'ERROR_FLOOR_PLAN_IMAGES',

	FETCH_QUOTATION_BY_ID = 'FETCH_QUOTATION_BY_ID',
	STORE_QUOTATION_BY_ID = 'STORE_QUOTATION_BY_ID',
	ERROR_QUOTATION_BY_ID = 'ERROR_QUOTATION_BY_ID',

	SET_LEAD_ID = 'SET_LEAD_ID',

	FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN = 'FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN',
	STORE_PRODUCT_CATEGORIES_FLOOR_PLAN = 'STORE_PRODUCT_CATEGORIES_FLOOR_PLAN',
	ERROR_FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN = 'ERROR_FETCH_PRODUCT_CATEGORIES_FLOOR_PLAN',

	UPLOAD_PROJECT_DETAILS = 'UPLOAD_PROJECT_DETAILS',

	CREATE_QUOTATION = 'CREATE_QUOTATION',

	FETCH_TICKET_CHAT = 'FETCH_TICKET_CHAT',
	STORE_TICKET_CHAT = 'STORE_TICKET_CHAT',
	ERROR_FETCH_TICKET_CHAT = 'ERROR_FETCH_TICKET_CHAT',

	SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE',
	CLOSE_TICKET = 'CLOSE_TICKET',

	FETCH_2D_JSON = 'FETCH_2D_JSON',
	ERROR_FETCH_2D_JSON = 'ERROR_FETCH_2D_JSON',
	STORE_2D_JSON = 'STORE_2D_JSON',

	FETCH_3D_JSON = 'FETCH_3D_JSON',
	ERROR_FETCH_3D_JSON = 'ERROR_FETCH_3D_JSON',
	STORE_3D_JSON = 'STORE_3D_JSON',

	FETCH_SAVED_QUOTATION = 'FETCH_SAVED_QUOTATION',
}
